import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import ProjectSection from "../../components/ProjectSectionAbout/ProjectSectionAbout";
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.png'
import VideoSection from '../../components/VideoSection/VideoSection';
import FaqSection from '../../components/FaqSection/FaqSection';
import ContactSection from '../../components/Contactsection/ContactSection';


const AboutPage = () => {
    return (
      <Fragment>
        <Navbar hclass={"wpo-site-header wpo-site-header-s2"} Logo={Logo} />
        <PageTitle
          pageTitle={"Clínica: Espacios y equipos"}
          pagesub={"Clinica "}
        />
        <ProjectSection
          hclass={"project_section section-padding"}
          sliceEnd={6}
        />
        <VideoSection
          title="Tecnologías y resultados"
          subtitle="Las intervenciones más exitosas son realizadas con las tecnologías de vanguardia. Te contamos cuáles son las nuestras y sus resultados. "
        />
        <FaqSection />
        <ContactSection />
        <Footer hclass={"wpo-site-footer"} />
        <Scrollbar />
      </Fragment>
    );
};
export default AboutPage;
